import { render, staticRenderFns } from "./WLoading.vue?vue&type=template&id=101b64dc&scoped=true&"
import script from "./WLoading.vue?vue&type=script&lang=js&"
export * from "./WLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b64dc",
  null
  
)

export default component.exports